import { FC } from 'react';

const TileGridContainer: FC<{
  children: JSX.Element | JSX.Element[];
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={className ?? 'flex flex-wrap items-stretch w-full'}>
      {children}
    </div>
  );
};

export default TileGridContainer;
